import { ModifierFunction } from './base'

const avoid = (() => {
}) as unknown as ModifierFunction<any, any, 'avoid'>

avoid._defaults = {}

export default avoid
